import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  gDriveFilesForSelectedCourseAtom,
  selectedCourseAtom,
  sourceFilesForSelectedCourseAtom,
} from './atoms'
import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { usePairedFileForKey } from './hooks'
import { courseFilesSummary } from './utility'
import { formatDistanceToNow } from 'date-fns'
import { ActionButtons } from './ParseButton'
import { GDriveRetrieveButton } from './IngestionFromS3'
import { FileSummary } from './types'

export function SelectedCourse() {
  const selected = useAtomValue(selectedCourseAtom)

  if (!selected) return null

  return (
    <Box>
      <Box>{selected}</Box>
      <CurrentParsedUpload />
      <S3Files />
      <GDriveFiles />
      <GDriveRetrieveButton />
      <ActionButtons />
    </Box>
  )
}

function CurrentParsedUpload() {
  const pairedFile = usePairedFileForKey()

  return (
    <Box>
      Last Updated:{' '}
      {pairedFile
        ? `${formatDistanceToNow(new Date(pairedFile.last_modified))} ago`
        : 'Hasnt Been Parsed'}
    </Box>
  )
}

function S3Files() {
  const s3Files = useAtomValue(sourceFilesForSelectedCourseAtom)

  if (!s3Files) return null

  return (
    <Box padding="5px">
      <Box>Source Files</Box>
      <Box padding="8px">
        {s3Files.map(({ name, URL }) => {
          return (
            <Button key={name} href={URL} target="_blank">
              {name}
            </Button>
          )
        })}
      </Box>
    </Box>
  )
}

function GDriveFiles() {
  const files = useAtomValue(gDriveFilesForSelectedCourseAtom)
  const [courseSummary, setCourseSummary] = useState<FileSummary[]>()

  useEffect(() => {
    setCourseSummary(undefined)
    if (!files) return
    const summary = courseFilesSummary(files)
    setCourseSummary(summary)
  }, [files])

  if (!courseSummary) {
    return <Box>Parsing...</Box>
  }

  return (
    <Box padding="5px">
      <Box>GDrive Files</Box>
      <Box padding="8px">
        {courseSummary.map((summaryData) => {
          return (
            <SummaryData
              key={summaryData.courseKey}
              summaryData={summaryData}
            />
          )
        })}
      </Box>
    </Box>
  )
}

function SummaryData({ summaryData }: { summaryData: FileSummary }) {
  const { courseKey, lessons, hasAsmt, hasTbk } = summaryData
  if (!lessons) {
    return <Box>{courseKey} We need GDrive Content Source</Box>
  }
  const [lessonStart, lessonEnd, ...missing] = lessons
  return (
    <Box>
      <Box>{courseKey}</Box>
      <Box padding="7px">
        {!lessonStart && <Box>MISSING LESSON FILES</Box>}
        {!!lessonStart && (
          <Box>
            Lessons {`${lessonStart} - ${lessonEnd}`}
            {!!missing.length && `MISSING: ${missing.join(', ')}`}
          </Box>
        )}
        <Box>
          {hasAsmt
            ? 'Has ASMT'
            : 'MISSING ASMT - Without this we dont have the assessment overview or material table'}
        </Box>
        <Box>
          {hasTbk
            ? 'Has TBK'
            : 'MISSING TBK - Without this we dont have Teacher Background Knowledge'}
        </Box>
      </Box>
    </Box>
  )
}
